import {Component, Input, SimpleChanges} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {AlarmFilterMatcherResult} from "../../models/core/alert-rule.model";
import { SelectModule } from 'primeng/select';
import * as _ from 'lodash';

@Component({
    selector: 'cc-query-builder',
    standalone: true,
    imports: [
        FormsModule,
        SelectModule,
        NgClass,
    ],
    templateUrl: './query-builder.component.html',
    styleUrl: './query-builder.component.scss'
})
export class QueryBuilderComponent {
    readonly STATIC = 'STATIC';
    @Input() isReadOnly: true = true;
    @Input() parentValue: AlarmFilterMatcherResult;
    @Input() query: AlarmFilterMatcherResult;
    @Input() comparisonType: string;

    readonly DATA_POINT_DOES_NOT_EXIST = "Data Point does not exist";

    constructor() {
    }
}
